// Users
export const GET_ALL_USERS = "/get-all-users";
export const USER_SIGNUP = "/user-save-info";
export const USER_CHECKOUT = "/user-checkout";
export const GET_PAYMENT_PLANS = "/get-payment-plans";
export const GET_PAYMENT_PLAN_INFO = "/get-payment-plan-info";

//AUth
export const USER_LOGIN = "/login";

//Categories
export const GET_ALL_CATEGORIES = "/get-all-categories";

//save-user-requested-contest
export const SAVE_USER_CONTEST = "/save-user-requested-contest";
export const GET_ALL_CONTEST = "/get-all-contest";
export const GET_CONTEST_DETAIL = "/get-contest-detail";
export const CREATE_CONTEST = "/create-contest";
export const CREATE_PARTICIPATE = "/create-participate";
export const SAVE_CONTEST_RESULT = "/save-contest-result";
export const GET_CONTEST_COMMENTS = "/get-contest-comments";
export const SAVE_CONTEST_COMMENTS = "/save-comments";
export const GET_CONTEST_RESULT = "/get-contest-result";
export const SAVE_CONTEST_STATUS = "/save-contest-status"
export const RESULT_SEND_TO_CLIENT = "/send-result-to-client"
export const HANDLE_START_DESIGN = "/start-designing";

//Users
export const GET_USER_PROFILE = "/get-user-profile";
export const GET_USER_REQUESTS = "/get-user-requests";
export const ACCEPT_REJECT_USER_REQUEST = "/accept-reject-user-request";
export const GET_MY_PARTICIPATED_CONTESTS = "/get-my-participated-contests";

export const GET_ADMIN_STAT = "/get-admin-stat";
export const GET_USER_SUBSCRIBE_PLAN_REVENUE = "/get-subscribe-plans";
export const GET_ADMIN_REVENUE = "/get-admin-revenue";
export const GET_EVENT_EARNING = "/get-event-earning";
export const GET_USER_REWARDS = "/get-config-rewards-list";

//
export const GET_REQUEST_DETAIL = "/get-request-detail";

//Notifications
export const GET_NOTIFICATIONS = "/get-notifications";

export const GET_ALL_STATUSES = "/get-all-statuses";

//get-artist-wins-rewards
export const GET_ARTIST_WINS_REWARDS = "/get-artist-wins-rewards";
export const ADD_REWARDS = "/save-rewards";
export const ADD_WINNER_REWARDS = "/assign-reward-to-winner";
export const GET_REWARD_DETAILS = "/get-config-rewards-list";

//Events
export const GET_ALL_EVENTS = "/get-all-events";
export const GET_EVENT_BY_ID = "/find-event-by-id";
export const GET_IN_HOUSE_ARTISTS = "/get-available-artist";
export const ADD_EVENTS = "/save-events";
export const DELETE_EVENT = "/delete-event";



